"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypeSelect = void 0;
const React = require("react");
const react_1 = require("react");
const HStack_1 = require("../../../../../components/base/structure/HStack");
const OptionsToggle_1 = require("../../../../../components/base/atoms/OptionsToggle");
const TSalesOrderType_1 = require("../../types/TSalesOrderType");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const OrderTypeContext_1 = require("../../contexts/OrderTypeContext");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "OrderTypeSelect");
const OrderTypeSelect = ({ retailLocation, onOrderTypeSelect }) => {
    const { orderType, setOrderType } = (0, useRequiredContext_1.useRequiredContext)(OrderTypeContext_1.OrderTypeContext);
    const orderTypeOptions = [TSalesOrderType_1.TSalesOrderType.Pickup, TSalesOrderType_1.TSalesOrderType.Delivery];
    const orderTypeCaptions = (0, react_1.useMemo)(() => {
        if (!retailLocation) {
            return null;
        }
        const { orderingTimes: { averagePickupTime, averageDeliveryTime }, deliveryCost } = retailLocation;
        return [
            `${averagePickupTime}min`,
            `$${deliveryCost.toFixed(2)} - ${averageDeliveryTime}min`
        ];
    }, [retailLocation]);
    (0, react_1.useEffect)(() => {
        onOrderTypeSelect && onOrderTypeSelect(orderType);
    }, []);
    const updateOrderType = (0, react_1.useCallback)(async (selectedOrderType) => {
        if (!selectedOrderType) {
            return;
        }
        if (typeof onOrderTypeSelect !== "function") {
            setOrderType(selectedOrderType);
            return;
        }
        const success = await onOrderTypeSelect(selectedOrderType);
        success && setOrderType(selectedOrderType);
    }, []);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("options") },
            React.createElement(HStack_1.HStack, null,
                React.createElement(OptionsToggle_1.OptionsToggle, { className: css("toggle"), optionWidth: "50%", options: [orderTypeOptions[0], orderTypeOptions[1]], optionCaptions: orderTypeCaptions, onToggleSelected: async (option) => {
                        const selectedOrderType = orderTypeOptions.find(orderTypeOption => orderTypeOption === option);
                        await updateOrderType(selectedOrderType);
                    }, selected: orderType })))));
};
exports.OrderTypeSelect = OrderTypeSelect;
//# sourceMappingURL=index.js.map